module.exports = __webpack_public_path__ + "img/yqm.28956265.png";